import { Controller } from "@hotwired/stimulus"

// A figure's Edit page, Brands & related: "Find a figure that goes with it"
// searches the catalogue (figures#lookup) as you type; picking one puts its
// id in the form and enables Relate. The kind menu's "add_on:theirs" says
// the picked figure is the add-on (the relation runs from it).
export default class extends Controller {
  static targets = ["input", "results", "id", "kind", "kindField", "direction", "submit"]
  static values = { url: String, self: Number }

  search() {
    this.idTarget.value = ""
    if (this.hasSubmitTarget) this.submitTarget.disabled = true
    clearTimeout(this.timer)
    const query = this.inputTarget.value.trim()
    if (query.length < 2) return this.close()
    this.timer = setTimeout(() => this.fetch(query), 200)
  }

  async fetch(query) {
    const url = new URL(this.urlValue, window.location.origin)
    url.searchParams.set("q", query)
    const response = await fetch(url, { headers: { Accept: "application/json" } })
    if (!response.ok || query !== this.inputTarget.value.trim()) return
    const figures = (await response.json()).filter((figure) => figure.id !== this.selfValue)
    this.resultsTarget.replaceChildren(...figures.map((figure) => this.row(figure)))
    this.resultsTarget.hidden = figures.length === 0
    this.active = -1
  }

  row(figure) {
    const button = document.createElement("button")
    button.type = "button"
    button.className = "cx-result"
    button.setAttribute("role", "option")
    const pic = document.createElement(figure.image ? "img" : "span")
    pic.className = "cx-result-pic"
    if (figure.image) { pic.src = figure.image; pic.alt = "" }
    const name = document.createElement("b")
    name.textContent = figure.name
    const chip = document.createElement("span")
    chip.className = "ui-chip brand"
    chip.textContent = figure.brand
    const note = document.createElement("span")
    note.className = "ui-note cx-result-note"
    note.textContent = figure.detail || ""
    button.append(pic, name, chip, note)
    button.addEventListener("click", () => this.pick(figure))
    return button
  }

  pick(figure) {
    this.idTarget.value = figure.id
    this.inputTarget.value = figure.label || figure.name
    if (this.hasSubmitTarget) this.submitTarget.disabled = false
    this.close()
    this.dispatch("picked", { detail: figure }) // for what names it (New reviews' Move button)
  }

  kindChanged() {
    const [kind, direction] = this.kindTarget.value.split(":")
    this.kindFieldTarget.value = kind
    this.directionTarget.value = direction || "mine"
  }

  key(event) {
    const rows = [...this.resultsTarget.querySelectorAll(".cx-result")]
    if (this.resultsTarget.hidden || rows.length === 0) return
    if (event.key === "ArrowDown" || event.key === "ArrowUp") {
      event.preventDefault()
      this.active = (this.active + (event.key === "ArrowDown" ? 1 : rows.length - 1)) % rows.length
      rows.forEach((row, i) => row.classList.toggle("is-active", i === this.active))
    } else if (event.key === "Enter") {
      // The active result, else the first: picked, and nothing else acts on this Enter.
      event.preventDefault()
      event.stopImmediatePropagation()
      rows[Math.max(this.active, 0)].click()
    } else if (event.key === "Escape") {
      this.close()
    }
  }

  close() {
    this.resultsTarget.hidden = true
  }
}
